import {useRef} from "react";
import {useParams} from "react-router";
import {css} from "@panda/css";

import {Button} from "@pg-design/button-module";
import {WideContent} from "@pg-design/grid-module";
import {Loader} from "@pg-design/loader-module";
import {IRankingAnnualParams, IRankingParams, rpAppLink} from "@pg-mono/rp-routes";
import {useUserDevice} from "@pg-mono/user-device";

import {useGetRegionDetailListBySlugQuery} from "../../../region/api/get_region_detail_list_by_slug";
import {offerRedirectTracking} from "../../tracking/offer_redirect_tracking";
import {AnnualRankingLinks} from "../AnnualRankingLinks";
import {LocationRankingDescription} from "../LocationRankingDescription";
import {OfferRankingForm} from "../offer_ranking_form/OfferRankingForm";
import {OfferRankingExpert} from "../OfferRankingExpert";
import {OfferRankingPanel} from "../OfferRankingPanel";
import {OfferRankingList} from "./offer_ranking_list/OfferRankingList";
import {OfferRankingBanner} from "./OfferRankingBanner";
import {OfferRankingBreadcrumbs} from "./OfferRankingBreadcrumbs";
import {OfferRankingCreationSteps} from "./OfferRankingCreationSteps";

export function OfferRanking() {
    const {citySlug} = useParams<IRankingParams | IRankingAnnualParams>();
    const creationStepsRef = useRef<HTMLDivElement>(null);
    const {data, isUninitialized, isLoading, isSuccess} = useGetRegionDetailListBySlugQuery({slug: citySlug});
    const region = data?.results[0];
    const {isMobile} = useUserDevice();

    const handleGetMoreInfoClick = () => {
        if (creationStepsRef.current) {
            creationStepsRef.current.scrollIntoView({behavior: "smooth"});
        }
    };

    return (
        <article>
            {(isUninitialized || isLoading) && <Loader />}
            {isSuccess && region && (
                <>
                    <WideContent>
                        <OfferRankingBreadcrumbs />
                        {isMobile && <OfferRankingPanel />}
                        {!isMobile && <OfferRankingForm horizontal />}
                        <div className={rankingContent}>
                            <OfferRankingBanner handleGetMoreInfoClick={handleGetMoreInfoClick} region={region} />
                            <OfferRankingList />
                            <Button
                                variant="filled_primary"
                                size="big"
                                className="ranking_button"
                                href={rpAppLink.offer.listFriendly({friendlySlug: `nowe-mieszkania-${region.slug}`})}
                                onClick={() => {
                                    offerRedirectTracking({city: region.name});
                                }}
                            >
                                zobacz nowe mieszkania <br className="button_break" />
                                {region.name_declension_where}
                            </Button>
                            <OfferRankingCreationSteps centerLayout scrollRefElem={creationStepsRef} />
                        </div>
                    </WideContent>
                    <OfferRankingExpert />
                    <WideContent className={footerContent}>
                        <LocationRankingDescription currentRegion={region} />
                        <AnnualRankingLinks />
                    </WideContent>
                </>
            )}
        </article>
    );
}

const rankingContent = css({
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: 8,
    paddingTop: 3,
    paddingBottom: 7,

    "& .ranking_button": {
        mb: 4,
        maxWidth: "100%"
    },

    "& .button_break": {
        display: "none",

        "@media (max-width: 500px)": {
            display: "block"
        }
    }
});

const footerContent = css({
    paddingTop: 8,
    paddingBottom: 0,
    paddingLeft: 0,
    paddingRight: 0
});
import {useRef} from "react";
import {useParams} from "react-router";
import {css} from "@panda/css";

import {Button} from "@pg-design/button-module";
import {WideContent} from "@pg-design/grid-module";
import {Loader} from "@pg-design/loader-module";
import {IRankingAnnualParams, IRankingParams, rpAppLink} from "@pg-mono/rp-routes";
import {useUserDevice} from "@pg-mono/user-device";

import {useGetRegionDetailListBySlugQuery} from "../../../region/api/get_region_detail_list_by_slug";
import {offerRedirectTracking} from "../../tracking/offer_redirect_tracking";
import {AnnualRankingLinks} from "../AnnualRankingLinks";
import {LocationRankingDescription} from "../LocationRankingDescription";
import {OfferRankingForm} from "../offer_ranking_form/OfferRankingForm";
import {OfferRankingExpert} from "../OfferRankingExpert";
import {OfferRankingPanel} from "../OfferRankingPanel";
import {OfferRankingList} from "./offer_ranking_list/OfferRankingList";
import {OfferRankingBanner} from "./OfferRankingBanner";
import {OfferRankingBreadcrumbs} from "./OfferRankingBreadcrumbs";
import {OfferRankingCreationSteps} from "./OfferRankingCreationSteps";

export function OfferRanking() {
    const {citySlug} = useParams<IRankingParams | IRankingAnnualParams>();
    const creationStepsRef = useRef<HTMLDivElement>(null);
    const {data, isUninitialized, isLoading, isSuccess} = useGetRegionDetailListBySlugQuery({slug: citySlug});
    const region = data?.results[0];
    const {isMobile} = useUserDevice();

    const handleGetMoreInfoClick = () => {
        if (creationStepsRef.current) {
            creationStepsRef.current.scrollIntoView({behavior: "smooth"});
        }
    };

    return (
        <article>
            {(isUninitialized || isLoading) && <Loader />}
            {isSuccess && region && (
                <>
                    <WideContent>
                        <OfferRankingBreadcrumbs />
                        {isMobile && <OfferRankingPanel />}
                        {!isMobile && <OfferRankingForm horizontal />}
                        <div className={rankingContent}>
                            <OfferRankingBanner handleGetMoreInfoClick={handleGetMoreInfoClick} region={region} />
                            <OfferRankingList />
                            <Button
                                variant="filled_primary"
                                size="big"
                                className="ranking_button"
                                href={rpAppLink.offer.listFriendly({friendlySlug: `nowe-mieszkania-${region.slug}`})}
                                onClick={() => {
                                    offerRedirectTracking({city: region.name});
                                }}
                            >
                                zobacz nowe mieszkania <br className="button_break" />
                                {region.name_declension_where}
                            </Button>
                            <OfferRankingCreationSteps centerLayout scrollRefElem={creationStepsRef} />
                        </div>
                    </WideContent>
                    <OfferRankingExpert />
                    <WideContent className={footerContent}>
                        <LocationRankingDescription currentRegion={region} />
                        <AnnualRankingLinks />
                    </WideContent>
                </>
            )}
        </article>
    );
}

const rankingContent = css({
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: 8,
    paddingTop: 3,
    paddingBottom: 7,

    "& .ranking_button": {
        mb: 4,
        maxWidth: "100%"
    },

    "& .button_break": {
        display: "none",

        "@media (max-width: 500px)": {
            display: "block"
        }
    }
});

const footerContent = css({
    paddingTop: 8,
    paddingBottom: 0,
    paddingLeft: 0,
    paddingRight: 0
});
